export default "__VITE_ASSET__Ckm5NsJg__"